import * as actions from '../actions/ReprintTool'

const initialState = {
  error: '',
  loading: false,
  searchResults: [],
  reprintSuccess: [],
  reprintFailed: [],
  isMoreResultAvailable: false
}

const ReprintToolReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.SEARCH_REPRINT_PACKAGES_LOADER:
      return {
        ...state,
        loading: action.loading
      }
    case actions.GET_REPRINT_PACKAGES:
      return {
        ...state,
        searchResults: action.packages
      }
    case actions.GET_REPRINT_PACKAGES_ERROR:
      return {
        ...state,
        error: action.error
      }
    case actions.GET_REPRINT_PACKAGES_SEARCH_LIMIT:
      return {
        ...state,
        isMoreResultAvailable: action.isMoreResultAvailable
      }
    case actions.POST_REPRINT_PACKAGES_SUCCESS:
      return {
        ...state,
        reprintSuccess: action.reprintSuccess
      }
    case actions.POST_REPRINT_PACKAGES_FAILED:
      return {
        ...state,
        reprintFailed: action.reprintFailed
      }
    case actions.POST_REPRINT_PACKAGES_ERROR:
      return {
        ...state,
        error: action.error
      }
    default:
      return state
  }
}

export default ReprintToolReducer
